import { DeliveryMode } from "@reef-os/utils/enums/deliveryMode"
import { BusinessType } from "@reef-os/utils/enums/businessType"
import { MenuType } from "@reef-os/utils/enums/menuType"

let orderSuccessMixin = {
	computed: {
		orderId: function () {
			return this.$route.params.order_id
		},
		businessType: function () {
			return this.$store.state.business.type
		},
		orderStatus() {
			return this.$store.state.orderStatus
		},
		deliveryMode() {
			return this.orderStatus.delivery_mode != undefined
				? this.orderStatus.delivery_mode
				: DeliveryMode.DIRECT_TO_LOCATION
		},
		deliveryHintTitle() {
			let title = "Help Your Courier Find You"
			switch (this.deliveryMode) {
				case DeliveryMode.DIRECT_TO_LOCATION:
					title =
						this.businessType == BusinessType.BAR
							? title
							: "Room Service"
					break
				case DeliveryMode.PICKUP_AREA:
					title = "Find Your Food"
					break
				case DeliveryMode.DIRECT_TO_CUSTOMER:
					title = "Courier Will Call"
			}
			return title
		},
		deliveryHintText() {
			switch (this.deliveryMode) {
				case DeliveryMode.DIRECT_TO_LOCATION: {
					switch (this.businessType) {
						case BusinessType.BAR: {
							return "Make sure your table number is placed on your table"
						}
						case BusinessType.HOTEL: {
							return "Your order will be delivered straight to your room!"
						}
						case BusinessType.RESIDENTIAL: {
							return "Your order will be delivered straight to your apartment!"
						}
						case BusinessType.COWORKING: {
							return "Your order will be delivered straight to your suite!"
						}
					}
					break
				}
				case DeliveryMode.YAY_FOOD_POLE: {
					return "Make sure to grab an orange sign and place it on your table"
				}
				case DeliveryMode.PICKUP_AREA: {
					return "Look out for a text that your food is ready to be picked up."
				}
				case DeliveryMode.DIRECT_TO_CUSTOMER: {
					return "Your courier will call you when they arrive"
				}
				case DeliveryMode.LAST_YARD: {
					return "Your courier will deliver to the location you specified and may contact you to assist in finding your location"
				}
			}
			return "Look out for a text that your food is ready to be picked up."
		},
		deliveryHintImagePath() {
			let path = "/images/"
			switch (this.deliveryMode) {
				case DeliveryMode.LAST_YARD:
				case DeliveryMode.DIRECT_TO_LOCATION: {
					path +=
						this.businessType == BusinessType.BAR
							? "2k-table.png"
							: "2k-room.png"
					break
				}
				case DeliveryMode.YAY_FOOD_POLE: {
					path += "2k-yay-food.png"
					break
				}
				case DeliveryMode.PICKUP_AREA: {
					path +=
						this.orderStatus.menu_type == MenuType.POPUP
							? "2k-phone.png"
							: "2k-pickup.png"
					break
				}
				case DeliveryMode.DIRECT_TO_CUSTOMER: {
					path += "2k-phone.png"
					break
				}
			}
			return path
		}
	}
}

export default orderSuccessMixin
